// src/utils/normalize.js

/**
 * Basic slugify for JTBD/product keys.
 * Keeps ascii letters/numbers, collapses separators, trims dashes.
 */
export function slugify(input = '') {
    return String(input)
      .toLowerCase()
      .normalize('NFKD')             // handle accents
      .replace(/[^\w\s-]/g, '')      // drop non-word chars
      .replace(/[\s_]+/g, '-')       // spaces/underscores -> dash
      .replace(/-+/g, '-')           // collapse dashes
      .replace(/^-|-$/g, '');        // trim dashes
  }
  
  /**
   * Normalize a product name from story data.
   * (You can extend this with a map of known aliases.)
   */
  export function normProductName(name = '') {
    const s = String(name).trim();
    if (!s) return '';
    // Example alias map (extend as needed)
    const ALIASES = {
      'manual price updates': 'Manual price updates',
      'generic dynamic pricing tool': 'Dynamic pricing tool',
    };
    const key = s.toLowerCase();
    if (ALIASES[key]) return ALIASES[key];
    // Title-case fallback
    return s[0].toUpperCase() + s.slice(1);
  }
  
  /**
   * Normalize a JTBD label from story data (category strings).
   */
  export function normJtbdName(name = '') {
    return String(name || '').trim();
  }
  
  /**
   * Derive a stable JTBD key (slug) from various inputs.
   */
  export function jtbdKeyFromName(name = '') {
    return slugify(normJtbdName(name));
  }
  
  /**
   * Derive JTBD key from a filename like:
   *   "i-want-to-identify-profitable-properties__satisfaction.json"
   *   "i-want-to-identify-profitable-properties__next_goals.json"
   *   "i-want-to-identify-profitable-properties.json" (job map)
   */
  export function jtbdKeyFromFilename(filename = '') {
    const base = String(filename).replace(/\.json$/i, '');
    return slugify(base.replace(/__(satisfaction|next_goals)$/i, ''));
  }
  
  /**
   * Pull numeric with safe fallback.
   */
  export function toNumber(v, fallback = 0) {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  }
  
  /**
   * Clamp a number into [min, max].
   */
  export function clamp(n, min = 0, max = 10) {
    const x = Number(n);
    if (!Number.isFinite(x)) return min;
    return Math.max(min, Math.min(max, x));
  }
  